import React, { createContext, useContext } from 'react';
import useUsers from '../hooks/userUsers';

const UsersContext = createContext();

export const UsersProvider = ({ children }) => {
  const users = useUsers();
  return (
    <UsersContext.Provider value={users}>
      {children}
    </UsersContext.Provider>
  );
};

export const useUsersContext = () => useContext(UsersContext);
